import Vue from 'vue'
import moment from 'moment'
import find from 'lodash/find'
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import i18n from './plugins/i18n'

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('L')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('L HH:mm')
  }
})

Vue.filter('formatLabel', function (value, dateFormat) {
  if (dateFormat === '[CW] WW') {
    dateFormat = `[${i18n.t('CW')}] WW`
  }
  value = moment(value).format(dateFormat)
  
  return value === 'Invalid date' ? '' : value
})

Vue.filter('formatUser', function (value) {
  if (value) {
    const firstName = value.firstName || ''
    const lastName = value.lastName || ''
    return `${[firstName, lastName].join(' ')} (${value.username})`
  }
})

Vue.filter('formatDisplayName', function (value) {
  if (value) {
    const firstName = value.firstName || ''
    const lastName = value.lastName || ''
    const inactive = value.active ? '' : `(${i18n.t('Inactive')})`
    return `${[firstName, lastName, inactive].join(' ')}`
  }
})

Vue.filter('formatLanguage', function (value) {
  if (value) {
    const en = find(value, ['language', 'en'])
    const de = find(value, ['language', 'de'])
    return {
      en: get(en, 'text'),
      de: get(de, 'text')
    }
  }
})

Vue.filter('languageString', function (value, locale = null) {
  if (isArray(value)) {
    return (
      find(value, ['language', locale || i18n.locale]) ||
      find(value, ['language', 'en']) ||
      {}
    ).text
  }
  return value
})

Vue.filter('changeToBr', function (value) {
  if (value) {
    return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
  }
})

Vue.filter('formatNumber', function (value, precision = null) {
  if (value !== null && value !== undefined) {
    return Number(value).toLocaleString('de', {minimumFractionDigits: precision, maximumFractionDigits: precision})
  }
  return value
})
